import { render, staticRenderFns } from "./HonjoFileViewer.vue?vue&type=template&id=0572f45e"
import script from "./HonjoFileViewer.vue?vue&type=script&lang=ts"
export * from "./HonjoFileViewer.vue?vue&type=script&lang=ts"
import style0 from "./HonjoFileViewer.vue?vue&type=style&index=0&id=0572f45e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports